import { TContactStateRoutesMap } from '@/config/types'
import { AppCountryTier } from '@/enums/appCountryTier'
import { MobileOperationSystem } from '@/enums/mobileOperationSystem'
import { PageName } from '@/enums/pageName'
import { PaymentMethod } from '@/enums/payments'

import { TContactAccessState } from '@/api/types'

import { getPath } from './urlUtils'

export function getDefaultPaymentMethod(
  currentMobileOS: MobileOperationSystem,
  tier: AppCountryTier,
  walletType: PaymentMethod | undefined
): PaymentMethod | undefined {
  if (currentMobileOS === MobileOperationSystem.IOS) {
    if (tier === AppCountryTier.T1 || tier === AppCountryTier.T2) {
      return walletType || PaymentMethod.CARD
    }
    return PaymentMethod.CARD || PaymentMethod.PAYPAL
  }
  if (currentMobileOS === MobileOperationSystem.ANDROID) {
    return PaymentMethod.CARD || PaymentMethod.PAYPAL
  }
  return PaymentMethod.CARD || PaymentMethod.PAYPAL
}

export function isApplePayAvailable() {
  const session = window.ApplePaySession
  if (!session) {
    return false
  }

  try {
    return session.canMakePayments()
  } catch (e) {
    return false
  }
}

export function prepareContactStateRoutesMap(
  stateRoutes: TContactStateRoutesMap
): Record<TContactAccessState, string> {
  return {
    has_partner_account: getPath(stateRoutes.has_partner_account || PageName.alreadyHasAccount),
    has_subscription: getPath(stateRoutes.has_subscription || PageName.alreadyPaid),
  }
}
